module.exports = __webpack_public_path__ + "img/check-white.29ae85ed.svg";